import BurgerIcon from "../burger-icon/BurgerIcon";
export default class MainMenu{

    constructor(){
        let me=this;
        /**
         *
         * @type {BurgerIcon}
         */
        this._burgerIcon=new BurgerIcon($("#toggle-nav"));
        /**
         * Elements qui constituent la nav et qui sont affichés / masqués
         * @type {*|jQuery|HTMLElement}
         * @private
         */
        this._$navs=$("#nav,#mr-hide");

        $body.on("click","a[nav-layout]",function(e){
            e.preventDefault();
            e.stopPropagation();
            switch ($(this).attr("href")){
                case "#toggle":
                    me.toggle();
                    break;
                case "#open":
                    me.open();
                    break;
                case "#close":
                    me.close();
                    break;
            }
        });

        $("#nav .ze-menu").on('transitionend webkitTransitionEnd oTransitionEnd', function () {
            console.log("hop")
            if($root.is(".nav-open")){
                me._burgerIcon.close();
            }else{
                me._burgerIcon.menu();
            }
        });


    }



    /**
     * Ouvre la nav
     */
    open(){
        $root.addClass("nav-open");

    }
    /**
     * ferme la nav
     */
    close(){
        $root.removeClass("nav-open");
        //this._burgerIcon.menu();

    }
    /**
     * ouvre / ferme la nav
     */
    toggle(){
        if($root.hasClass("nav-open")){
            this.close();
        }else{
            this.open();
        }

    }
}



// WEBPACK FOOTER //
// ./fk.app/_src/layout/MainMenu.js